"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserCompanyRole = void 0;
var UserCompanyRole;
(function (UserCompanyRole) {
    UserCompanyRole["SUPER_ADMIN"] = "super_admin";
    UserCompanyRole["SUPER_USER"] = "super_user";
    UserCompanyRole["VALIDATOR"] = "validator";
    UserCompanyRole["USER"] = "user";
})(UserCompanyRole || (exports.UserCompanyRole = UserCompanyRole = {}));
//# sourceMappingURL=userCompanyRole.enum.js.map